import React, {useContext, useEffect, useState} from 'react';
import './Tasks.css'
import {useNavigate} from "react-router-dom";
import {Context} from "../../index";
import {fetchAllTasks} from "../../http/TaskAPI";
import {fetchFiles} from "../../http/FileAPI";
import {observer} from "mobx-react-lite";
import {fetchComment} from "../../http/CommentsAPI";
import {fetchStatement} from "../../http/StatementAPI";
import SearchComponent from "../SearchComponent/SearchComponent";
import TaskNewSmall from "../TaskCategorySmall/TaskNewSmall";
import TaskJobSmall from "../TaskCategorySmall/TaskJobSmall";
import TaskStatementSmall from "../TaskCategorySmall/TaskStatementSmall";
import TaskCloseSmall from "../TaskCategorySmall/TaskCloseSmall";
import TaskMobileNew from "../TaskMobile/TaskMobileNew";
import TaskMobileJob from "../TaskMobile/TaskMobileJob";
import TaskMobileStat from "../TaskMobile/TaskMobileStat";
import TaskMobileClose from "../TaskMobile/TaskMobileClose";
import PinningPage from "../PinningPage/PinningPage";

const Tasks = () => {

    const navigate = useNavigate()
    const {taskStore, fileStore, commentStore, statementStore} = useContext(Context)
    const [searchName, setSearchName] = useState('')
    const [searchPriority, setSearchPriority] = useState('')
    const [taskMob, setTaskMob] = useState(1)


    useEffect(() => {
        fetchAllTasks().then(data => taskStore.setTask(data))
        fetchFiles().then(data => fileStore.setFile(data))
        fetchComment().then(data => commentStore.setComments(data))
        fetchStatement().then(data => statementStore.setStatement(data))
    }, [])

    let date = new Intl.DateTimeFormat("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })

    const filteredPriority = taskStore.task.filter(task => task
        ?
        task.priority?.toString().includes(searchPriority)
        :
        false)

    const filteredTask = filteredPriority.filter(t => t
        ?
        t.name?.toLowerCase().includes(searchName.toLowerCase())
        :
        false)

    const TaskWithFileAndComment = filteredTask.map(task => {
        const withFileId = fileStore.file.filter(file => file['taskId'] === task['id'])
        const file = withFileId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const withCommentId = commentStore.comments.filter(comm => comm['taskId'] === task['id'])
        const comm = withCommentId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const withSratementId = statementStore.statement.filter(state => state['taskId'] === task['id'])
        const state = withSratementId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        return {...task, fileto: file, comment: comm, statement: state}
    })

    return (
        <div className="tasks__block">
            <SearchComponent setSearchName={setSearchName} searchName={searchName} searchPriority={searchPriority}
                             setSearchPriority={setSearchPriority}/>
            <div className="all__tasks__block">
                <TaskNewSmall
                    TaskWithFileAndComment={TaskWithFileAndComment}
                    navigate={navigate}
                    date={date}
                />
                <TaskJobSmall
                    TaskWithFileAndComment={TaskWithFileAndComment}
                    navigate={navigate}
                    date={date}
                />
                <TaskStatementSmall
                    TaskWithFileAndComment={TaskWithFileAndComment}
                    navigate={navigate}
                    date={date}
                />
                <TaskCloseSmall
                    TaskWithFileAndComment={TaskWithFileAndComment}
                    navigate={navigate}
                    date={date}
                />
            </div>

            <div className="task__mobile__block">
                <div className="nav__task__mobile__block">
                    <div className={taskMob === 1 ? "nav__task__mobile__active" : "nav__task__mobile"}
                         onClick={() => setTaskMob(1)}>
                        Не назначенные
                    </div>
                    <div className={taskMob === 2 ? "nav__task__mobile__active" : "nav__task__mobile"}
                         onClick={() => setTaskMob(2)}>
                        В работе
                    </div>
                    <div className={taskMob === 3 ? "nav__task__mobile__active" : "nav__task__mobile"}
                         onClick={() => setTaskMob(3)}>
                        На утверждении
                    </div>
                    <div className={taskMob === 4 ? "nav__task__mobile__active" : "nav__task__mobile"}
                         onClick={() => setTaskMob(4)}>
                        Выполненые
                    </div>
                </div>

                <TaskMobileNew
                    taskMob={taskMob}
                    TaskWithFileAndComment={TaskWithFileAndComment}
                    navigate={navigate}
                    date={date}
                />
                <TaskMobileJob
                    taskMob={taskMob}
                    TaskWithFileAndComment={TaskWithFileAndComment}
                    navigate={navigate}
                    date={date}
                />
                <TaskMobileStat
                    taskMob={taskMob}
                    TaskWithFileAndComment={TaskWithFileAndComment}
                    navigate={navigate}
                    date={date}
                />
                <TaskMobileClose
                    taskMob={taskMob}
                    TaskWithFileAndComment={TaskWithFileAndComment}
                    navigate={navigate}
                    date={date}
                />

            </div>

            <PinningPage/>


        </div>
    );
};

export default observer(Tasks);